(() => {
  if (!window.swinger.user.isLoggedIn()) {
    return;
  }

  window.swinger.observer.initialize('.plyr', (elem) => {
    window.swinger.visibility.activeElement.track(elem);
  }, false);

  // See: https://www.w3.org/TR/uievents-key/#named-key-attribute-value
  document.addEventListener('keydown', (e) => {
    if (
      e.ctrlKey
      || e.altKey
      || e.metaKey
    ) {
      return;
    }

    const { activeElement } = document;

    if (activeElement.matches('a, button, input, select, textarea, [contenteditable], label')) {
      return;
    }

    const container = window.swinger.visibility.activeElement.get('.plyr');

    if (!container) {
      return;
    }

    const player = window.swinger.players.find((player) => player.elements && player.elements.container && player.elements.container === container);

    if (!player) {
      return;
    }

    switch (e.key) {
      default:
        return;

      case ' ':
      case 'k':
      case 'MediaPlayPause':
        // Play/Pause
        player.togglePlay();
        break;

      case 'MediaPlay':
        // Play
        player.play();
        break;

      case 'MediaPause':
      case 'Pause':
        // Pause
        player.pause();
        break;

      case 'MediaStop':
        // Stop
        player.stop();
        break;

      case '0':
      case 'Home':
        // Go to start
        player.restart();
        break;

      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        // Seek to 10% - 90%
        player.currentTime = player.duration * Number(e.key) * 0.1;
        break;

      case 'End':
        // Go to (almost) the end
        player.currentTime = player.duration * 0.975;
        break;

      case 'j':
      case 'ArrowLeft':
      case 'MediaRewind':
        // Seek backwards
        player.rewind();
        break;

      case 'l':
      case 'ArrowRight':
      case 'MediaFastForward':
      case 'FastFwd':
        // Seek forward
        player.forward();
        break;

      case '<':
      case '-':
      case 'PlaySpeedDown':
        // Slow down the video playback rate.
        player.speed = Math.max(0.5, player.speed / 2);
        break;

      case '>':
      case '+':
      case 'PlaySpeedUp':
        // Speed up the video playback rate.
        player.speed = Math.min(4, player.speed * 2);
        break;

      case 'PlaySpeedReset':
        // Reset the video playback rate
        player.speed = 1;
        break;

      case 'ArrowDown':
        if (player.stopped) {
          return;
        }
        // Decrease volume 5%
        player.decreaseVolume(0.05);
        break;

      case 'AudioVolumeDown':
        // Decrease volume 5%
        player.decreaseVolume(0.05);
        break;

      case 'ArrowUp':
        if (player.stopped) {
          return;
        }
        // Increase volume 5%.
        player.increaseVolume(0.05);
        break;

      case 'AudioVolumeUp':
        // Increase volume 5%.
        player.increaseVolume(0.05);
        break;

      case 'm':
      case 'AudioVolumeMute':
        // Toggle mute
        player.muted = !player.muted;
        break;

      case 'f':
      case 'ZoomToggle':
        // Toggle fullscreen
        try {
          player.fullscreen.toggle();
        } catch (e) {
          // noop
        }
        break;

      case 'ZoomIn':
        // Enter fullscreen
        try {
          if (!player.fullscreen.active) {
            Promise.resolve(player.fullscreen.enter()).catch((e) => console.log(e));
          }
        } catch (e) {
          // noop
        }
        break;

      case 'ZoomOut':
      case 'Escape':
        // Exit fullscreen
        try {
          if (player.fullscreen.active) {
            Promise.resolve(player.fullscreen.exit()).catch((e) => console.log(e));
          }
        } catch (e) {
          // noop
        }
        break;

      case 'c':
      case 'Subtitle':
        // Toggle closed caption
        player.toggleCaptions();
        break;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);
})();
